/**
 * @file: filterPath.
 * @authors: zhengyanfeng (zhengyanfeng@fjxhx.com).
 * @createDate: 2020/7/30.
 * @versionss: 1.0.
 * @copyright © 2019 新和兴 All rights reserved.
 */


/**
 * 过滤开发请求路径
 * @author: dawangf(dawangf@sina.com)
 * @createDate: 2020/7/20
 * @param {String} type 请求接口类型
 * @return {string}
 */
function filterPathDev(type) {
  let path = ''
  // console.log(type, '11111111111111')
  switch (type) {
    case 'auth': // 旧企盟家的认证
      path = '/auth'
      break
    case 'base': // swagger
      path = '/fjxhx/base/server/api'
      break
    case 'biz': // 旧6300的接口
      path = '/szsa/biz/server/api'
      break
    case 'device': // 新的6400
      path = '/szsa/device/server/api'
      break
    default:
      path = ''
  }
  return path
}

/**
 * 过滤测试请求路径
 * @author: dawangf(dawangf@sina.com)
 * @createDate: 2020/7/20
 * @param {String} type 请求接口类型
 * @return {string}
 */
function filterPathStag(type) {
  let path = ''
  switch (type) {
    case 'auth':
      path = '/auth'
      break
    case 'base': // swagger
      path = '/fjxhx/base/server/api'
      break
    case 'biz': // 旧6300的接口
      path = '/szsa/biz/server/api'
      break
    case 'device': // 新的6400
      path = '/szsa/device/server/api'
      break
    default:
      path = ''
  }
  return path
}

/**
 * 过滤正式请求路径
 * @author: dawangf(dawangf@sina.com)
 * @createDate: 2020/7/20
 * @param {String} type 请求接口类型
 * @return {string}
 */
function filterPathProd(type) {
  let path = ''
  switch (type) {
    case 'auth':
      path = '/auth'
      break
    case 'base': // swagger
      path = '/fjxhx/base/server/api'
      break
    case 'biz': // 旧6300的接口
      path = '/szsa/biz/server/api'
      break
    case 'device': // 新的6400
      path = '/szsa/device/server/api'
      break
    default:
      path = ''
  }
  return path
}

/**
 * 过滤请求路径
 * @author: dawangf(dawangf@sina.com)
 * @createDate: 2020/7/20
 * @param {String} type 请求接口类型
 * @return {string}
 */
export function filterPath(type) {
  const ENV = process.env.NODE_ENV
  let path = ''
  switch (ENV) {
    case 'development':
      path = filterPathDev(type)
      break
    case 'staging':
      path = filterPathStag(type)
      break
    case 'production':
      path = filterPathProd(type)
      break
    default:
      path = filterPathDev(type)
  }
  return path
}

/**
 * 过滤请求是否是 responseType 为 blob
 * @author: dawangf(dawangf@sina.com)
 * @createDate: 2020/7/20
 * @param {String} url 请求url
 * @return {string}
 */
export function filterIsBlob() {
  // // 请求文件对象url数组
  // const BLOBS = [
  //   '/fjxhx/gis/anchor/type/icon/show',
  //   'threshold/list/export/get',
  //   'history/list/export/get',
  //   'statistics/list/export/get'
  // ]
  // return BLOBS.includes(url)
}



// WEBPACK FOOTER //
// ./src/utils/filterPath.js